import { atom } from "jotai";

/**
 * Atom to track if the PageBlockAddMenu component is open.
 * Used to suppress mouse enter/leave events for blocks that are not focused.
 */

export const isAddBlockMenuOpen = atom<boolean>(false);
